module.exports = __webpack_public_path__ + "static/media/phone.7c52742a.png";